import * as actions from '../utils/Constants';
import Routes from '../utils/Routes';
import { apiRequest, Methods } from '../utils/Api';
const api = `${process.env.REACT_APP_API_HOST}api/course/`;

export const getCourse = (id) => {
    return dispatch => dispatch({
        type: actions.GET_COURSE,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/course/${id}`, Methods.get, null, dispatch)
    });
};

export const updateCourse = (grant) => {
    return {
        type: actions.UPDATE_COURSE,
        payload: fetch(api, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(grant),
        }).then(res => {
            return res.json();
        })
    }
}

export const deleteSection = (courseId, sectionId = []) => {
    return dispatch => dispatch({
        type: actions.DELETE_SECTION,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/courses/`, Methods.delete, sectionId, dispatch).then(res => {
            dispatch(getCourse(courseId));
            return {};
        })
    })
}

export const setField = (field, value) => ({
    type: actions.SET_COURSE_FIELD,
    field,
    payload: value
});

export const newCourse = (parentId) => ({ type: actions.NEW_SECTION, payload: parentId });

export const addSections = (sections) => ({ type: actions.ADD_COURSE_SECTIONS, payload: sections });

export const copySectionToCourse = (courseId, sectionIds) => {
    return dispatch => dispatch({
        type: actions.COPY_SECTION,
        payload: apiRequest(Routes.course + courseId, Methods.post, sectionIds, dispatch)
    });
};